import { render, staticRenderFns } from "./trawl-upload-list.vue?vue&type=template&id=651dde61"
import script from "./trawl-upload-list.vue?vue&type=script&lang=js"
export * from "./trawl-upload-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports